export var ContentTaskSubType;
(function (ContentTaskSubType) {
    ContentTaskSubType[ContentTaskSubType["UNPUBLISH"] = 10] = "UNPUBLISH";
    ContentTaskSubType[ContentTaskSubType["UPDATE"] = 20] = "UPDATE";
    ContentTaskSubType[ContentTaskSubType["NEW"] = 30] = "NEW";
    ContentTaskSubType[ContentTaskSubType["REDONE"] = 40] = "REDONE";
    ContentTaskSubType[ContentTaskSubType["QUICK_TASK"] = 50] = "QUICK_TASK";
    ContentTaskSubType[ContentTaskSubType["BATCH"] = 60] = "BATCH";
    ContentTaskSubType[ContentTaskSubType["ON_HOLD"] = 70] = "ON_HOLD";
    ContentTaskSubType[ContentTaskSubType["OTHER"] = 80] = "OTHER";
})(ContentTaskSubType || (ContentTaskSubType = {}));
//# sourceMappingURL=content-task-sub-type.enum.js.map